import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../context/LanguageContext';

const seoData = {
  ru: {
    home: {
      title: 'Capitara | Возврат средств через банковские процедуры — 87% успешность',
      description: 'Capitara — международная финансовая компания по возврату средств через банковские процедуры. 15+ лет опыта, 87% успешность, работа в 80+ странах. Оплата только за результат.',
    },
    form: {
      title: 'Бесплатная консультация | Capitara — возврат средств',
      description: 'Оставьте заявку на бесплатную консультацию по возврату средств. Наши специалисты оценят вашу ситуацию и предложат оптимальную стратегию возврата.',
    },
    success: {
      title: 'Заявка отправлена | Capitara',
      description: 'Ваша заявка успешно отправлена. Наш менеджер свяжется с вами в ближайшее время.',
    },
  },
  en: {
    home: {
      title: 'Capitara | Fund Recovery Through Banking Procedures — 87% Success Rate',
      description: 'Capitara is an international financial company specializing in fund recovery through banking procedures. 15+ years of experience, 87% success rate, operating in 80+ countries. Payment only for results.',
    },
    form: {
      title: 'Free Consultation | Capitara — Fund Recovery',
      description: 'Submit a request for a free consultation on fund recovery. Our specialists will assess your situation and offer the best recovery strategy.',
    },
    success: {
      title: 'Request Submitted | Capitara',
      description: 'Your request has been successfully submitted. Our manager will contact you shortly.',
    },
  },
  ar: {
    home: {
      title: 'Capitara | استرداد الأموال من خلال الإجراءات المصرفية — نسبة نجاح 87%',
      description: 'Capitara هي شركة مالية دولية متخصصة في استرداد الأموال من خلال الإجراءات المصرفية. أكثر من 15 عاماً من الخبرة، نسبة نجاح 87%، نعمل في أكثر من 80 دولة.',
    },
    form: {
      title: 'استشارة مجانية | Capitara — استرداد الأموال',
      description: 'قدم طلباً للحصول على استشارة مجانية حول استرداد أموالك. سيقيم خبراؤنا وضعك ويقدمون أفضل استراتيجية للاسترداد.',
    },
    success: {
      title: 'تم إرسال الطلب | Capitara',
      description: 'تم إرسال طلبك بنجاح. سيتصل بك مديرنا في أقرب وقت.',
    },
  },
};

export default function SEOHead({ page = 'home' }) {
  const { currentLang } = useLanguage();
  const data = seoData[currentLang]?.[page] || seoData.ru[page] || seoData.ru.home;

  return (
    <Helmet>
      <html lang={currentLang} dir={currentLang === 'ar' ? 'rtl' : 'ltr'} />
      <title>{data.title}</title>
      <meta name="description" content={data.description} />
      <meta property="og:title" content={data.title} />
      <meta property="og:description" content={data.description} />
      <meta name="twitter:title" content={data.title} />
      <meta name="twitter:description" content={data.description} />
    </Helmet>
  );
}
